import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Personal from './pages/Personal';
import Study from './pages/Study';
import AgentChat from './pages/AgentChat';
import Game from './pages/Game';
import Exchange from './pages/Exchange';
import Admin from './pages/Admin';
import BottomNav from './components/BottomNav';
import ShuTongFab from './components/ShuTongFab';
import { ShuTongProvider } from './context/ShuTongContext';
import './App.css';

function App() {
  return (
    <Router>
      <ShuTongProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/personal" element={<Personal />} />
            <Route path="/study" element={<Study />} />
            <Route path="/agent" element={<AgentChat />} />
            <Route path="/study/agent" element={<AgentChat />} />
            <Route path="/game" element={<Game />} />
            <Route path="/exchange" element={<Exchange />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <ShuTongFab />
          <BottomNav />
        </div>
      </ShuTongProvider>
    </Router>
  );
}

export default App;